var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function setFiltersToLocalStorage(pageLocation, label, value) {
    var _a, _b;
    var localStorageFilters = getDataFromLocalStorage(pageLocation);
    var newLocalStorageFilters = localStorageFilters
        ? __assign(__assign({}, localStorageFilters), (_a = {}, _a[label] = value, _a)) : (_b = {}, _b[label] = value, _b);
    var stringifyValue = JSON.stringify(newLocalStorageFilters);
    localStorage.setItem(pageLocation, stringifyValue);
}
export function getDataFromLocalStorage(label) {
    var stringifyValue = localStorage.getItem(label);
    return stringifyValue ? JSON.parse(stringifyValue) : null;
}
export var setLocalStorage = function (key, value) {
    if (!value) {
        localStorage.removeItem(key);
    }
    else {
        localStorage.setItem(key, value);
    }
};
//# sourceMappingURL=localStorage.js.map